module.exports = __webpack_public_path__ + "static/media/twitter_logobutton.a2029be3.svg";